module.exports = __webpack_public_path__ + "static/media/eyeclose.fef68d95.svg";